'use client';

import { Button, TrilogyColor } from '@bytel/trilogy-react-ts';

import { CartContent } from '@components/cart-content';

import { useApp } from '@hooks/use-app';
import { useCart } from '@hooks/use-cart';

import { panierRoute } from '@helpers/routes';

export const CartModal = ({ onClose }: Readonly<{ onClose: () => void }>) => {
    const { goTo } = useApp();
    const { byouCart } = useCart();

    const updatedCart = () => {
        onClose();
        goTo(panierRoute.path);
    };

    if (!byouCart?.gencode) {
        return null;
    }

    return (
        <>
            <div className='has-text-left'>
                <CartContent cart={byouCart} />
                <div className='level-item mt-4'>
                    <Button variant={TrilogyColor.PRIMARY} onClick={updatedCart}>
                        Modifier ma commande
                    </Button>
                </div>
            </div>
        </>
    );
};
